/**
 * Manual Y, between the chart that holds it and the menu that shows it.
 *
 * A dragged price axis stays where it was put until ›| (owner, 2026-10-16;
 * `docs/features/charts.md` › Axes and ranging). The builder holds that state,
 * and it lives in `ChartGroupView`; right-click › Settings is built in `App`.
 * So the chart publishes here and the menu asks here — `symbol-index.ts`'s
 * module-scope shape, for its reason. Not saved: nothing here outlives the page.
 */

type Mode = "auto" | "manual";

const manual = new Set<string>();
const commands = new Map<string, (mode: Mode) => void>();

/** The chart reports what its builder now holds. */
export function publishYManual(chartGroupId: string, isManual: boolean): void {
  if (isManual) manual.add(chartGroupId);
  else manual.delete(chartGroupId);
}

/** Whether this chart's Y axis is held by hand — the menu's ✓ on *Manual*. */
export function isYManual(chartGroupId: string): boolean {
  return manual.has(chartGroupId);
}

/** The chart takes requests for itself. Returns the unregister. */
export function onYAxisMode(chartGroupId: string, apply: (mode: Mode) => void): () => void {
  commands.set(chartGroupId, apply);
  return () => {
    if (commands.get(chartGroupId) !== apply) return;
    commands.delete(chartGroupId);
    manual.delete(chartGroupId);
  };
}

/** The menu asks: back to the fit, or freeze the range on screen. */
export function requestYAxisMode(chartGroupId: string, mode: Mode): void {
  commands.get(chartGroupId)?.(mode);
}
